module.exports = __webpack_public_path__ + "static/media/AngelsOfAether-Gallery-16.67ddc950.jpg";